import React from 'react';
import { ControllerFieldState, ControllerRenderProps, FieldValues } from 'react-hook-form';
import { Text, TextVariant } from '@naf/text';
import { ProductType } from '@dtp/membership-service-types';
import useSelector from '@redux/typedHooks';
import { Spinner } from '@components/spinner/Spinner';
import { ProductID } from '@lib/ProductID';
import { defaultProduct } from '../DrivingPermit';
import * as S from './Product.styles';

export const ProductSelect = ({
  field: { value = defaultProduct, onChange },
  fieldState: { error },
}: {
  field: ControllerRenderProps<FieldValues, 'product'>;
  fieldState: ControllerFieldState;
}) => {
  const user = useSelector((state) => state.myMembership.customerInformation.data);
  const products = useSelector((state) => state.internationalDrivingPermit.data.eligibleProducts);
  const originalProducts = useSelector((state) => state.internationalDrivingPermit.data.originalEligibleProducts);
  const isUpdating = useSelector((state) => state.becomeAMember.isUpdating);
  const isMember = user?.membership?.isValid ?? false;
  const isNotMemberLabel = 'ikke medlem';
  const displayProducts = originalProducts || products;
  const idpProductArray =
    displayProducts &&
    (displayProducts[ProductID.Idp1Year] ||
      displayProducts[ProductID.Idp3Year] ||
      displayProducts[ProductID.Idp1and3Year])
      ? [
          displayProducts[ProductID.Idp1Year],
          displayProducts[ProductID.Idp3Year],
          displayProducts[ProductID.Idp1and3Year],
        ]
      : null;

  if (error) return <Text variant={TextVariant.ArticleTextHeader}>{error.message}</Text>;

  if (!products && !isUpdating)
    return (
      <Text variant={TextVariant.ArticleTextHeader}>
        Oops, vi har problemer med motoren... Ta kontakt med kundesenteret hvis problemet fortsetter!
      </Text>
    );

  if (!products && isUpdating) return <Spinner />;

  const createLabel = (id: string) => {
    switch (id) {
      case ProductID.Idp1Year:
        return '1-årig';
      case ProductID.Idp3Year:
        return '3-årig';
      case ProductID.Idp1and3Year:
        return '1-årig og 3-årig';
      default:
        return null;
    }
  };

  return idpProductArray ? (
    <S.RadioButtonGroup>
      {idpProductArray.map(
        (product: ProductType) =>
          product &&
          typeof product !== 'undefined' && (
            <S.StyledRadioButton
              data-testid="product-select"
              onChange={() => {
                onChange({
                  productId: product.productNumber,
                  amount: product.productAppPrice[1].itemCount.toFixed(0),
                  isLoggedIn: value.isLoggedIn,
                });
              }}
              checked={value.productId === product.productNumber}
              variant="tile"
              key={product.productNumber}
              label={createLabel(product.productNumber) || product.productName}
              byline={`${product.productAppPrice[1].itemTotalPrice},- ${isMember ? '' : isNotMemberLabel}`}
              name="fullRadio"
            />
          ),
      )}
    </S.RadioButtonGroup>
  ) : (
    <Text variant={TextVariant.ArticleTextHeader}>
      Oops, vi har problemer med motoren... Ta kontakt med kundesenteret hvis problemet fortsetter!
    </Text>
  );
};
